const o = {
  styleOverrides: {
    root: {
      "&&": {
        borderRadius: "8px",
        textTransform: "none",
        boxShadow: "none"
      }
    }
  }
};
export {
  o as buttonBase
};
//# sourceMappingURL=buttonBase2.mjs.map
